import { Space, Transition } from '@sravni/react-design-system';
import type { ComponentPropsWithoutRef } from 'react';
import React, { useState } from 'react';

import type { TVitrinsOffersCardProps } from 'shared/ui/VitrinsOffersCard';

import { ShowMoreOffers } from '../ShowMoreOffers/ShowMoreOffers';

import styles from './OtherOffers.module.scss';

type Props = ComponentPropsWithoutRef<'div'> & {
  offersType: TVitrinsOffersCardProps['type'];
  countOffers: number;
};

export const OtherOffers: FC<Props> = (props) => {
  const { offersType, children, countOffers } = props;
  const [isActiveShowMore, setIsActiveShowMore] = useState(false);

  return (
    <Space
      size={8}
      direction="vertical"
    >
      <ShowMoreOffers
        countOffers={countOffers}
        isShowMore={isActiveShowMore}
        offersType={offersType}
        onClick={() => setIsActiveShowMore(!isActiveShowMore)}
      />
      <Transition.Collapse visible={isActiveShowMore}>
        <Space
          size={20}
          className={styles.otherOffers}
          direction="vertical"
        >
          {children}
        </Space>
      </Transition.Collapse>
    </Space>
  );
};
